(function () {
  const MODAL_SELECTOR = '.image-banner-login-modal';
  const LOGIN_MODAL_SELECTOR = '.image-banner-login-modal--login';
  const REGISTER_MODAL_SELECTOR = '.image-banner-login-modal--register';

  function openModal(modal) {
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
    const input = modal.querySelector('input:not([type="hidden"])');
    if (input) {
      setTimeout(function () {
        input.focus();
      }, 0);
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    const openCount = document.querySelectorAll(MODAL_SELECTOR + ':not([hidden])').length;
    if (openCount <= 1) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  function closeAllInSection(sectionRoot) {
    sectionRoot.querySelectorAll(MODAL_SELECTOR).forEach(function (modal) {
      closeModal(modal);
    });
    document.body.classList.remove('overflow-hidden');
  }

  function handleClick(sectionRoot, event) {
    const modal = event.target.closest(MODAL_SELECTOR);
    const container = event.target.closest('.image-banner-login-modal__container');
    if (modal && !container && !modal.hasAttribute('hidden')) {
      event.preventDefault();
      closeModal(modal);
      document.body.classList.remove('overflow-hidden');
      return;
    }
    const action = event.target.closest('[data-action]');
    if (!action) return;
    const actionName = action.getAttribute('data-action');
    if (actionName === 'open-login-modal') {
      event.preventDefault();
      closeAllInSection(sectionRoot);
      const loginModal = sectionRoot.querySelector(LOGIN_MODAL_SELECTOR);
      if (loginModal) loginModal.classList.remove('image-banner-login-modal--recover-visible');
      openModal(loginModal);
    } else if (actionName === 'open-register-modal') {
      event.preventDefault();
      closeAllInSection(sectionRoot);
      const registerModal = sectionRoot.querySelector(REGISTER_MODAL_SELECTOR);
      openModal(registerModal);
    } else if (actionName === 'close-modal') {
      event.preventDefault();
      const modalToClose = event.target.closest(MODAL_SELECTOR);
      if (modalToClose) closeModal(modalToClose);
      document.body.classList.remove('overflow-hidden');
    } else if (actionName === 'show-recover' || actionName === 'show-login') {
      event.preventDefault();
      const modal = action.closest(MODAL_SELECTOR);
      if (!modal) return;
      const loginView = modal.querySelector('.image-banner-login-modal__login-view');
      const recoverView = modal.querySelector('.image-banner-login-modal__recover-view');
      if (actionName === 'show-recover') {
        modal.classList.add('image-banner-login-modal--recover-visible');
        if (recoverView) {
          const input = recoverView.querySelector('input:not([type="hidden"])');
          if (input) setTimeout(function () { input.focus(); }, 0);
        }
      } else {
        modal.classList.remove('image-banner-login-modal--recover-visible');
        if (loginView) {
          const input = loginView.querySelector('input:not([type="hidden"])');
          if (input) setTimeout(function () { input.focus(); }, 0);
        }
      }
    }
  }

  function handleKeydown(event) {
    if (event.code !== 'Escape') return;
    const openModalEl = document.querySelector(MODAL_SELECTOR + ':not([hidden])');
    if (openModalEl) {
      closeModal(openModalEl);
      document.body.classList.remove('overflow-hidden');
    }
  }

  function initSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.imageBannerLoginInited === 'true') return;
    sectionRoot.dataset.imageBannerLoginInited = 'true';
    sectionRoot.addEventListener('click', function (e) {
      handleClick(sectionRoot, e);
    });
  }

  function init() {
    document.querySelectorAll('.image-banner-login').forEach(initSection);
    document.addEventListener('keydown', handleKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.detail.sectionId;
    const sectionRoot = document.querySelector('#BannerLogin-' + section);
    if (sectionRoot && sectionRoot.classList.contains('image-banner-login')) {
      initSection(sectionRoot);
    }
  });
})();
